import styled from 'styled-components';
import { breakpoint, color, font } from 'styles/globals';
import { Theme, getBodyStyle, getColor } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const HeadContainer = styled.div`
  padding: 24px 16px;

  @media (${breakpoint.mdMin}) {
    margin-top: 48px;
  }
`;

export const TitleRanking = styled(Heading)`
  display: inline;
  text-decoration: underline;

  a {
    color: inherit;
  }

  &:hover {
    color: ${getColor('textLink')};
  }
`;

export const Wrapper = styled.div`
  background-color: ${color.lightBlue};
  display: block;
  min-height: 389px;

  @media (${breakpoint.mdMin}) {
    margin-left: -24px;
    margin-right: -24px;
  }

  @media (${breakpoint.xlMin}) {
    display: flex;
    margin-top: 72px;
    min-height: 390px;
    padding: 24px 48px 64px 48px;
    margin-left: -48px;
    margin-right: -48px;

    > div {
        flex: 1 1 50%;
        height: auto;
    }
  }

  figcaption {
    display: none;
  }
`;

export const AboutWrapper = styled.div<{ theme: Theme }>`
  @media (${breakpoint.xlMin}) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: calc(100% - 64px);
  }

  p {
    color: ${getColor('textPrimary')};
    font-family: ${font.graphikCond};
    font-size: 24px;
    font-weight: 300;
    line-height: 26.4px;
    margin-bottom: 0;
    margin-top: 16px;
    transition: all 0.25s;
  }
`;

export const AboutTitle = styled(Heading)`
  text-align: left;
  transition: all 0.25s;
  margin-top: 24px;
  margin-bottom: 0;
`;

export const TitleWrapper = styled.div<{ theme: Theme }>`
  color: ${getColor('textWhite')};
  height: auto;
  margin-top: 40px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 24px;

  @media (${breakpoint.mdMin}) {
    padding-left: 24px;
    padding-right: 24px;
    margin-top: 56px;
  }

  @media (${breakpoint.xlMin}) {
    margin-left: -48px;
    margin-top: -24px;
  }
`;

export const PeopleTitle = styled(Heading)`
  text-align: left;
  transition: all 0.25s;
  margin: 24px 0 0;

  @media (${breakpoint.xlMin}) {
    height: 80%;
    letter-spacing: -0.5px;
    margin: 0;
    position: relative;

    span {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }

`;

export const ContentWrapper = styled.div`
  @media (${breakpoint.mdMin}) {
    padding: 0;
  }

  @media (${breakpoint.mdMin}) {
    margin: 0 auto;
    max-width: 879px;
    padding: 0;
    width: calc((100vw - 96px)/12 * 9 - 16px);
  }

  @media (${breakpoint.xlMin}) {
    margin-left: 120px;
    margin-right: 48px;
    max-width: 879px;
  }
  
  h2 {
    padding: 0 10px;
  }

  & > .simple {
    margin-top: 48px;
  }
`;

export const Description = styled.div<{ theme: Theme }>`
  ${getBodyStyle('georgia', { default: 'default' })};
  text-align: left;
  margin: 16px 16px 96px;

  p:not( :first-child ) {
    margin-top: 24px;
  }

  @media (${breakpoint.lgMin}) {
    margin: 0 0 96px;
  }

  a {
    color: ${getColor('textLink')};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    &:active {
      text-decoration: none;
      color: ${getColor('textPrimary')};
    }
  }
`;

export const ImageWrapper = styled.div`
  @media (${breakpoint.xlMin}) {
    height: 400px;
    margin-top: -48px;
    width: 53%;
  }
`;

export const CreditWrapper = styled.div<{ theme: Theme }>`
  bottom: 0;
  color: ${getColor('textPrimary')};
  ${getBodyStyle('graphikCond', { default: 'small' })};
  font-weight: 500;
  left: 0;
  letter-spacing: 0.58px;
  line-height: 21px;
  padding: 4px 16px 24px 16px;
  position: relative;

  @media (${breakpoint.mdMin}) {
    padding: 4px 24px 32px 24px;
  }

  @media (${breakpoint.xlMin}) {
    border: none;
    padding: 5px 0;
    top: 0;
  }

  & > span {
    color: ${getColor('textSecondary')};
    font-weight: 400;
    font-size: 12px;
    letter-spacing: 1px;
    line-height: 18px;
    text-transform: uppercase;
    display: block;
  }
`;

export const WrapperDesc = styled.div`
  display: block;
  margin-top: 16px;
  max-width: none;
  padding: 0;

  @media (${breakpoint.xlMin}) {
    display: flex;
    margin: 0;
    margin-top: 48px;
  }

  > div {

    &:nth-child(2) {
      margin-top: 24px;
      min-width: 18.75rem;
      padding: 0 16px;

      @media (${breakpoint.mdMin}) {
        padding: 0;
      }
    }

    &:last-child {
      align-items: center;
      margin: auto;
      padding: 0 16px;

      @media (${breakpoint.mdMin}) {
        margin-top: 16px;
        padding: 0 24px;
      }

      @media (${breakpoint.lgMin}) {
        padding: 0;
      }

      @media (${breakpoint.xlMin}) {
        align-items: center;
        display: flex;
        flex-direction: column;
        margin: 0;
        min-width: 300px;
        width: calc((100% - 96px)/12 * 3 + 96px);
      }
    }
  }
`;

export const RightRail = styled.div`
  @media (${breakpoint.xlMax}) {
    display: flex;
    justify-content: center;
  }
`;
